export type CurrencyType = {
  id: string;
};

export const CURRENCIES: CurrencyType[] = [
  // These values must appeared in top of lists
  { id: 'EUR' },
  { id: 'USD' },
  { id: 'GBP' },
  { id: 'CHF' },
  { id: 'AUD' },
  { id: 'NZD' },
  // End

  { id: 'AED' },
  { id: 'AFN' },
  { id: 'ALL' },
  { id: 'AMD' },
  { id: 'ANG' },
  { id: 'AOA' },
  { id: 'ARS' },
  { id: 'AWG' },
  { id: 'AZN' },
  { id: 'BAM' },
  { id: 'BBD' },
  { id: 'BDT' },
  { id: 'BGN' },
  { id: 'BHD' },
  { id: 'BIF' },
  { id: 'BMD' },
  { id: 'BND' },
  { id: 'BOB' },
  { id: 'BOV' },
  { id: 'BRL' },
  { id: 'BSD' },
  { id: 'BTN' },
  { id: 'BWP' },
  { id: 'BYN' },
  { id: 'BZD' },
  { id: 'CAD' },
  { id: 'CDF' },
  { id: 'CHE' },
  { id: 'CHW' },
  { id: 'CLF' },
  { id: 'CLP' },
  { id: 'CNY' },
  { id: 'COP' },
  { id: 'COU' },
  { id: 'CRC' },
  { id: 'CUC' },
  { id: 'CUP' },
  { id: 'CVE' },
  { id: 'CZK' },
  { id: 'DJF' },
  { id: 'DKK' },
  { id: 'DOP' },
  { id: 'DZD' },
  { id: 'EGP' },
  { id: 'ERN' },
  { id: 'ETB' },
  { id: 'FJD' },
  { id: 'FKP' },
  { id: 'GEL' },
  { id: 'GHS' },
  { id: 'GIP' },
  { id: 'GMD' },
  { id: 'GNF' },
  { id: 'GTQ' },
  { id: 'GYD' },
  { id: 'HKD' },
  { id: 'HNL' },
  { id: 'HRK' },
  { id: 'HTG' },
  { id: 'HUF' },
  { id: 'IDR' },
  { id: 'ILS' },
  { id: 'INR' },
  { id: 'IQD' },
  { id: 'IRR' },
  { id: 'ISK' },
  { id: 'JMD' },
  { id: 'JOD' },
  { id: 'JPY' },
  { id: 'KES' },
  { id: 'KGS' },
  { id: 'KHR' },
  { id: 'KMF' },
  { id: 'KPW' },
  { id: 'KRW' },
  { id: 'KWD' },
  { id: 'KYD' },
  { id: 'KZT' },
  { id: 'LAK' },
  { id: 'LBP' },
  { id: 'LKR' },
  { id: 'LRD' },
  { id: 'LSL' },
  { id: 'LYD' },
  { id: 'MAD' },
  { id: 'MDL' },
  { id: 'MGA' },
  { id: 'MKD' },
  { id: 'MMK' },
  { id: 'MNT' },
  { id: 'MOP' },
  { id: 'MRU' },
  { id: 'MUR' },
  { id: 'MVR' },
  { id: 'MWK' },
  { id: 'MXN' },
  { id: 'MXV' },
  { id: 'MYR' },
  { id: 'MZN' },
  { id: 'NAD' },
  { id: 'NGN' },
  { id: 'NIO' },
  { id: 'NOK' },
  { id: 'NPR' },
  { id: 'OMR' },
  { id: 'PAB' },
  { id: 'PEN' },
  { id: 'PGK' },
  { id: 'PHP' },
  { id: 'PKR' },
  { id: 'PLN' },
  { id: 'PYG' },
  { id: 'QAR' },
  { id: 'RON' },
  { id: 'RSD' },
  { id: 'RUB' },
  { id: 'RWF' },
  { id: 'SAR' },
  { id: 'SBD' },
  { id: 'SCR' },
  { id: 'SDG' },
  { id: 'SEK' },
  { id: 'SGD' },
  { id: 'SHP' },
  { id: 'SLL' },
  { id: 'SOS' },
  { id: 'SRD' },
  { id: 'SSP' },
  { id: 'STN' },
  { id: 'SVC' },
  { id: 'SYP' },
  { id: 'SZL' },
  { id: 'THB' },
  { id: 'TJS' },
  { id: 'TMT' },
  { id: 'TND' },
  { id: 'TOP' },
  { id: 'TRY' },
  { id: 'TTD' },
  { id: 'TWD' },
  { id: 'TZS' },
  { id: 'UAH' },
  { id: 'UGX' },
  { id: 'USN' },
  { id: 'UYI' },
  { id: 'UYU' },
  { id: 'UYW' },
  { id: 'UZS' },
  { id: 'VES' },
  { id: 'VND' },
  { id: 'VUV' },
  { id: 'WST' },
  { id: 'XAF' },
  { id: 'XAG' },
  { id: 'XAU' },
  { id: 'XBA' },
  { id: 'XBB' },
  { id: 'XBC' },
  { id: 'XBD' },
  { id: 'XCD' },
  { id: 'XDR' },
  { id: 'XOF' },
  { id: 'XPD' },
  { id: 'XPF' },
  { id: 'XPT' },
  { id: 'XSU' },
  { id: 'XTS' },
  { id: 'XUA' },
  { id: 'XXX' },
  { id: 'YER' },
  { id: 'ZAR' },
  { id: 'ZMW' },
  { id: 'ZWL' },
];
